import React, { useMemo } from "react";

import PropTypes from "prop-types";
import { get } from "lodash";

import { useAllocationProject } from "src/contexts/global/GlobalContext";
import { useWorkspace } from "src/contexts/global/WorkspaceContext";
import useFulfillVacantRole from "src/components/Person/PersonItem/sub-components/hooks/useFulfillVacantRole";
import ConfiguredActionMenu from "src/components/ConfiguredActionMenu";
import { copywriting } from "src/components/Person/PersonItem/PersonItem.config";
import { useAuth0 } from "src/contexts/auth0Provider";
import PersonPropType from "src/custom-prop-types/person";
import GroupPropType from "src/custom-prop-types/group";

const PERSON_ACTION_MENU_TYPE = {
  EDIT_ALLOCATIONS: "edit_allocations",
};

const PersonActionsMenu = ({
  direction = "right-start",
  onEditingAllocations,
  canChangeAllocations,
  onDisplayReportTeamChange,
  canReportTeamChange,
  person,
  group,
}) => {
  const workspace = useWorkspace();
  const groupTypes = get(workspace, "config.groupTypes");
  const { user } = useAuth0();
  const allocationProject = useAllocationProject();

  const { canShowFulfillButton, handleAddMember, vacantRoleLabel } =
    useFulfillVacantRole({
      person,
      group,
      workspace,
      user,
      groupTypes,
      allocationProject,
    });

  const actions = useMemo(() => {
    return [
      {
        type: PERSON_ACTION_MENU_TYPE.EDIT_ALLOCATIONS,
        className: "guided-tour-team-details-explore-in-org",
        label: copywriting.EDIT_ALLOCATIONS,
        onClick: onEditingAllocations,
        isEnabled: canChangeAllocations,
      },
      {
        type: PERSON_ACTION_MENU_TYPE.NOTIFY_TEAM_CHANGES,
        className: "guided-tour-team-details-explore-in-org",
        label: copywriting.NOTIFY_TEAM_CHANGES,
        onClick: onDisplayReportTeamChange,
        isEnabled: canReportTeamChange,
      },
      {
        type: PERSON_ACTION_MENU_TYPE.FULFILL_VACANT_ROLE,
        className: "guided-tour-team-details-explore-in-org",
        label: `Fulfil ${vacantRoleLabel} `,
        onClick: handleAddMember,
        isEnabled: canShowFulfillButton && canChangeAllocations,
      },
    ].filter((action) => action.isEnabled);
  }, [
    canChangeAllocations,
    onEditingAllocations,
    canReportTeamChange,
    onDisplayReportTeamChange,
    canShowFulfillButton,
    handleAddMember,
    vacantRoleLabel,
  ]);

  if (!actions.length) {
    return null;
  }

  return (
    <ConfiguredActionMenu direction={direction} ml="r" actions={actions} />
  );
};

PersonActionsMenu.propTypes = {
  direction: PropTypes.string,
  canChangeAllocations: PropTypes.bool,
  onEditingAllocations: PropTypes.func,
  canReportTeamChange: PropTypes.bool,
  onDisplayReportTeamChange: PropTypes.func,
  person: PersonPropType,
  group: GroupPropType,
};

export default PersonActionsMenu;
